import {
    SET_USER_SETTINGS,
    SET_USERKEY,
    SET_USER_ROLES,
    SET_USER_IS_ADMIN,
    SET_USER_IS_SUPER_ADMIN,
    SET_USER_IS_AVENCY,
    SET_USER_EMAIL,
    SET_USER_GIVEN_NAME,
    SET_USER_FAMILY_NAME,
    SET_USER_IMAGE,
    SET_USER_ACCESS_TOKEN,
    SET_EXPIRES_AT,
    SET_USER_IS_LOGGED_IN,
    SET_USER_AVAILABLE_DEMO_AMOUNT,
    SET_USER_AVAILABLE_DEMO_AMOUNT_FORMATTED,
    SET_LAST_CHANGELOG_HASH,
} from '../Actions/userSettingsActions';
import { ReducerHandler, UserSettings, ReducerAction } from '../../Types';

const initialState = {
    roles: [],
    isAdmin: false,
    isSuperAdmin: false,
    isAvency: false,
    isComplianceAdmin: false,
    isMaintainer: false,
    email: '',
    givenName: '',
    familyName: '',
    image: '',
    accessToken: '',
    expiresAt: 0,
    isLoggedIn: false,
    availableDemoAmount: -1,
    availableDemoAmountFormatted: '',
    userkey: '',
    hasUserPassword: false,
    userPasswordHash: '',
    identifier: '',
    lastChangelogHash: '',
} as UserSettings;

const userSettingsReducerMap: Record<string, ReducerHandler<UserSettings>> = {
    [SET_USER_SETTINGS]: (state, action) => ({ ...state, ...action.payload }),
    [SET_USERKEY]: (state, action) => ({ ...state, userkey: action.payload }),
    [SET_USER_ROLES]: (state, action) => ({ ...state, roles: action.payload }),
    [SET_USER_IS_ADMIN]: (state, action) => ({ ...state, isAdmin: action.payload }),
    [SET_USER_IS_SUPER_ADMIN]: (state, action) => ({ ...state, isSuperAdmin: action.payload }),
    [SET_USER_IS_AVENCY]: (state, action) => ({ ...state, isAvency: action.payload }),
    [SET_USER_EMAIL]: (state, action) => ({ ...state, email: action.payload }),
    [SET_USER_GIVEN_NAME]: (state, action) => ({ ...state, givenName: action.payload }),
    [SET_USER_FAMILY_NAME]: (state, action) => ({ ...state, familyName: action.payload }),
    [SET_USER_IMAGE]: (state, action) => ({ ...state, image: action.payload }),
    [SET_USER_ACCESS_TOKEN]: (state, action) => ({ ...state, accessToken: action.payload }),
    [SET_EXPIRES_AT]: (state, action) => ({ ...state, expiresAt: action.payload }),
    [SET_USER_IS_LOGGED_IN]: (state, action) => ({ ...state, isLoggedIn: action.payload }),
    [SET_USER_AVAILABLE_DEMO_AMOUNT]: (state, action) => ({ ...state, availableDemoAmount: action.payload }),
    [SET_USER_AVAILABLE_DEMO_AMOUNT_FORMATTED]: (state, action) => ({
        ...state,
        availableDemoAmountFormatted: action.payload,
    }),
    [SET_LAST_CHANGELOG_HASH]: (state, action) => ({ ...state, lastChangelogHash: action.payload }),
};

function userSettingsReducer(state = initialState, action: ReducerAction): UserSettings {
    const handler = userSettingsReducerMap[action.type];
    return handler ? handler(state, action) : state;
}
export default userSettingsReducer;
